/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { calendarConnectionResponseProviderSchema } from './CalendarConnectionResponseProviderSchema'

export const calendarConnectionResponseSchema = z.object({
	id: z.number(),
	provider: calendarConnectionResponseProviderSchema,
	accountEmail: z.string(),
	connectedAt: z.string(),
	needsReconnect: z.boolean(),
})

export type CalendarConnectionResponseSchema = z.infer<typeof calendarConnectionResponseSchema>
